// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index_" + {"8":"33af822b0a8e00986e3d","844":"039febfaf092ef39145b"}[chunkId] + "_" + chunkId + ".js";
};